import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium } from 'src/styles/font';
import { flex } from 'src/styles/utils';

export const LoggedInContainer = styled.div`
  color: ${colors.PlanTitleGrey};
  width: 100%;
  border-radius: 8px;
  ${ZeeFontMedium(12, 18)};
  box-shadow: 0px 4px 10px 0px ${rgba(colors.black, 0.25)};
  border: 1px solid ${rgba(colors.white, 0.25)};
  padding: 8px 16px;
  ${flex('row', 'start')};
`;
